import { WORKOUT_EXERCISE_KEY } from '../../../../workout-exercise/model'
import { SET_DATA_KEY } from '../../../../workout-exercise/model/constants'
import { getSetDataWorkoutExerciseUtil } from '../../../../workout-exercise/model/utils'
import { WORKOUT_SECTION_KEY } from '../../../model'
import getWorkoutExercisesWorkoutSectionUtil from '../../../model/utils/get-workout-exercises'
import updateReduxAction from '../../../../redux/actions/update'
import createPointerReduxUtil from '../../../../redux/utils/create-pointer'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import { getPathReduxUtil } from '../../../../redux/utils/get-path'
import { saveWorkoutExerciseAction } from '../../../../workout-exercise/redux/actions/save'
import updateWorkoutExerciseAction from '../../../../workout-exercise/redux/actions/update'
import WORKOUT_EXERCISES_ACTION from '../../../../workout-exercise/redux/constants/action'
import getCurrentWorkoutExerciseSelect from '../../../../workout-exercise/redux/selectors/get-current'
import WORKOUT_SECTIONS_ACTION from '../../constants/action'
import getCurrentWorkoutSectionSelect from '../../selectors/get-current'
import getCurrentWorkoutExercisesWorkoutSectionSelect from '../../selectors/get-current-workout-exercises'
import isCircuitWorkoutSectionSelector from '../../selectors/is-circuit'
import updateDataWorkoutAction from '../../../../workout/redux/actions/update-data'
import updateLocalIsDownloadedWorkoutAction from '../../../../workout/redux/actions/update-local-is-downloaded'

export default function addWorkoutExerciseAction () {
  return (dispatch, getState) => {
    const workoutSection = getCurrentWorkoutSectionSelect(getState())
    const workoutExercise = getCurrentWorkoutExerciseSelect(getState())
    const workoutExercisePointers = getWorkoutExercisesWorkoutSectionUtil(
      workoutSection)

    const isCircuit = isCircuitWorkoutSectionSelector(getState())
    const workoutExercises = getCurrentWorkoutExercisesWorkoutSectionSelect(
      getState())
    const lastWorkoutExercise = workoutExercises[workoutExercises.length - 1]
    const lastWorkoutExerciseSetData = getSetDataWorkoutExerciseUtil(
      lastWorkoutExercise)
    const lastWorkoutExerciseRestSets = lastWorkoutExerciseSetData.filter(set => set[SET_DATA_KEY.REST] !=
      null)
    const lastWorkoutExerciseRestSetsCount = lastWorkoutExerciseRestSets.length
    const workoutExerciseSetData = getSetDataWorkoutExerciseUtil(workoutExercise)
    const workoutExerciseRestSets = workoutExerciseSetData.filter(set => set[SET_DATA_KEY.REST] !=
      null)
    // If it's a circuit and the last exercise had rest, remove them
    if (workoutExerciseRestSets.length &&
      (
        (
          isCircuit && lastWorkoutExerciseRestSetsCount
        ) ||
        (
          !isCircuit && lastWorkoutExerciseRestSetsCount === 1
        )
      )) {
      dispatch(updateWorkoutExerciseAction({
        type: WORKOUT_EXERCISES_ACTION.DELETE_LAST_WORKOUT_EXERCISE_REST,
        payload: {
          key: WORKOUT_EXERCISE_KEY.SET_DATA,
          value: lastWorkoutExerciseSetData.reduce((newArr, set) => {
            if (set[SET_DATA_KEY.REST] != null) {
              return newArr
            }
            newArr.push(set)
            return newArr
          }, []),
          workoutExercise: lastWorkoutExercise
        }
      }))
    }

    const newWorkoutExercisePointers = [
      ...workoutExercisePointers,
      createPointerReduxUtil(workoutExercise)
    ]

    // Update the workout exercise's order
    // and
    // Update the workout section's workout exercises
    dispatch(updateReduxAction({
      type: WORKOUT_SECTIONS_ACTION.ADD_WORKOUT_EXERCISE,
      payload: {
        path: getPathReduxUtil(workoutSection),
        key: WORKOUT_SECTION_KEY.WORKOUT_EXERCISES,
        value: newWorkoutExercisePointers
      }
    }))

    // Update the workout's data
    dispatch(updateDataWorkoutAction())
    // Set the is local downloaded to false
    dispatch(updateLocalIsDownloadedWorkoutAction({
      value: false
    }))

    dispatch(saveWorkoutExerciseAction(getIdReduxUtil(workoutExercise)))
  }
}
